/**
 * Eventually will handle JWT authentication tokens, but for now it simply wraps around
 * a shared token.
 */
var Authenticator = /** @class */ (function () {
    function Authenticator(_token) {
        this._token = _token;
    }
    Object.defineProperty(Authenticator.prototype, "AuthenticationToken", {
        get: function () {
            return this._token;
        },
        set: function (v) {
            this._token = v;
        },
        enumerable: true,
        configurable: true
    });
    return Authenticator;
}());
export { Authenticator };



// WEBPACK FOOTER //
// ./src/app/shared/services/authenticator.ts.pre-build-optimizer.js